import common from '../base/common';
import emitter from '../base/emitter';

class News{

    constructor(isDetail){

        this.isDetail = isDetail;

        if(!this.isDetail)
            this.bindListingEvents();
        else
            this.bindDetailEvents();

    }

    bindListingEvents(){

        $('#page').on('click')
        console.log('listing');

    }

    bindDetailEvents(){

        console.log('detail');


    }

}

export default News;


// WEBPACK FOOTER //
// ./js/pages/news.js